import { localDate } from '@naturalcycles/js-lib'
import { BreakpointAction, ChoiceFunction, QuizDataInput } from '@naturalcycles/shared'
import { addPageToFlowAfterCurrent, removePagesFromFlow } from '@src/app/util/quiz.util.js'
import { DateOfGivingBirthBreakpointOption, DefaultQuizSection } from '@src/typings/quiz.enum.js'
import { QuizPage } from '../quiz-pages.cnst.js'

const addDateOfGivingBirthTransformFunction: ChoiceFunction<QuizPage, QuizDataInput> = (
  flow,
  data,
) => {
  const dateOfGivingBirth = data?.dateOfGivingBirth
  if (!dateOfGivingBirth) return flow

  const isMoreThanSixWeeksAgo = localDate(dateOfGivingBirth).isOlderThan(6, 'week')

  if (isMoreThanSixWeeksAgo) {
    return addPageToFlowAfterCurrent(
      flow,
      DefaultQuizSection.cycle,
      QuizPage.dateOfGivingBirth,
      QuizPage.periodBack,
    )
  }

  return removePagesFromFlow(flow, DefaultQuizSection.cycle, [
    QuizPage.periodBack,
    QuizPage.cycleStartDate,
  ])
}

const skipTransformFunction: ChoiceFunction<QuizPage, QuizDataInput> = (flow, _data) => {
  return addPageToFlowAfterCurrent(
    flow,
    DefaultQuizSection.cycle,
    QuizPage.dateOfGivingBirth,
    QuizPage.periodBack,
  )
}

export const dateOfGivingBirthBreakpoint: Required<
  BreakpointAction<DateOfGivingBirthBreakpointOption, QuizPage, QuizDataInput>
> = {
  [DateOfGivingBirthBreakpointOption.dateSelected]: addDateOfGivingBirthTransformFunction,
  [DateOfGivingBirthBreakpointOption.skip]: skipTransformFunction,
}
